import {
  Autocomplete,
  Box,
  CircularProgress,
  Divider,
  IconButton,
  Button,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { color } from "../../../../StyleData/Config";
import { Save } from "@mui/icons-material";
import { move, useFormik } from "formik";

import { axiosPrivate } from "../../../../axios/axios";
import { masterAPI } from "../../../Masters/dataConfig";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { isSystemAccess } from "../../../../ConfigInfo/Info";

const Transfer = ({ data, getData,enableDisable }) => {
  const trueDisable=!enableDisable.edit
  const [loading, setLoading] = useState(false);
  const [asset, setAsset] = useState({
    name: "",
    id: null,
    code: "",
  });
  // const [currentLocation, setCurrentLocation] = useState({ name: data.locationName||"", id: data.locationId||"",code:data.locationCode||"" });
  const [toLocation, setToLocation] = useState({ name: "", id: "", code: "" });
  const [toSystem, setToSystem] = useState({ name: "", id: "", code: "" });
  const [systemList, setSystemList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [parentAssetList, setParentAssetList] = useState([]);
  const [disableLocation, sedisableLocation] = useState(false);
  const [disableSystem, setDisableSystem] = useState(false);
  const [disableAsset, setdisableAsset] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const loginInfo = useSelector((state) => state.auth.loginInfo.siteId);
  const isSystem = useSelector((state) => isSystemAccess(state.auth.loginInfo));
  console.log("data", data.parentAssetId);

  useEffect(() => {
    if (isSystem) {
      const systemLink = masterAPI["system"].link;
      axiosPrivate
        .get(`${systemLink}`)
        .then((res) => {
          setSystemList(res.data.result.filter((fil) => fil.isActive));
        })
        .catch((e) => {
          setSystemList([]);
          console.log(e, "transferSystemGetAll");
        });
    }

    const locationLink = masterAPI["location"].link;
    axiosPrivate
      .get(`${locationLink}`)
      .then((res) => {
        setLocationList(res.data.result.filter((fil) => fil.isActive));
      })
      .catch((e) => {
        setLocationList([]);
        console.log(e, "transferLocationGetAll");
      });

    const assetLink = masterAPI["assets"].link;
    axiosPrivate
      .get(`${assetLink}`)
      .then((res) => {
        setParentAssetList(res.data.result.filter((fil) => fil.id !== data.id));
      })
      .catch((e) => {
        setParentAssetList([]);
        console.log(e, "transferAssetGetAll");
      });
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      fromParentAssetId: data.parentAssetId || null,
      fromParentAssetName: data.parentAssetName || "",
      fromParentAssetCode: data.parentAssetCode || "",
      toParentAssetId: asset.id || data.parentAssetId || null,
      toParentAssetName: asset.name || "",
      toParentAssetCode: asset.code || "",
      fromLocationCode: data.locationCode || "",
      fromLocationName: data.locationName || "",
      fromLocationId: data.locationId || null,
      toLocationCode: toLocation.code || "",
      toLocationId: toLocation.id || data.locationId || null,
      toLocationName: toLocation.name || "",
      fromSystemCode: data.systemCode || "",
      fromSystemName: data.systemName || "",
      fromSystemId: data.systemId || null,
      toSystemCode: toSystem.code || "",
      toSystemId: toSystem.id || data.systemId || null,
      toSystemName: toSystem.name || "",
      remarks: "",
    },
    enableReinitialize: true,
    onSubmit: async (value) => {
      setLoading(true);
      const postData = {
        assetId: data.id,
        siteId: loginInfo,
        ...value,
      };
      const movementLink = masterAPI["assetMovement"].create;
      console.log(postData);
      // if (data.parentAssetId) {
      //   const isLocationChanged = value.toLocationId !== data.locationId;
      //   const isParentChanged = value.toParentAssetId !== data.parentAssetId;
      //   if (isParentChanged && isLocationChanged) {
      //     toast.error(
      //       "Cannot transfer both Parent Asset and Location at the same time."
      //     );
      //     setLoading(false);
      //     return false;
      //   }
      // }
      // if (data.parentAssetId) {
      //   const isLocationChanged = value.toLocationId === data.locationId;
      //   if (isLocationChanged) {
      //     toast.error("Cannot transfer both Same Location.");
      //     setLoading(false);
      //     return false;
      //   }
      // }
      // if (data.parentAssetId) {
      //   const isParentChanged = value.toParentAssetId === data.parentAssetId;
      //   if (isParentChanged) {
      //     toast.error("Cannot transfer both Same Parent Asset.");
      //     setLoading(false);
      //     return false;
      //   }
      // }
      if (data.id === value.toParentAssetId) {
        toast.error("Asset cannot be set as its own parent.");
        return false;
      }
      await axiosPrivate
        .post(`${movementLink}`, postData)
        .then((res) => {
          console.log(res);
          getData();
          setAsset({ id: "", code: "", name: "" });
          setToLocation({ id: "", code: "", name: "" });
          setToSystem({ id: "", code: "", name: "" });
          sedisableLocation(false);
          setDisableSystem(false);
          setdisableAsset(false);
          setLoading(false);
        })
        .catch((e) => {
          console.log(e, "side Menu Transfer error");
          toast.error(e.response.data.failureMessage);
        });
    },
  });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <Box>
        <Typography
          sx={{
            color: color.sideTitleColor,
            fontSize: color.fontSizeSide,
            fontWeight: color.sideWeightFont,
          }}
        >
          Transfer
        </Typography>
      </Box>

      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "0.5rem",
          p: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={{
              color: color.sideTitle2Color,
              fontSize: color.fontSizeSide,
              fontWeight: color.sideFontWeight,
            }}
          >
            Details
          </Typography>
          {showConfirm ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography sx={{ color: "green" }}>
                Are you sure you want to transfer?
              </Typography>
              <Button
                onClick={() => {
                  formik.handleSubmit();
                  setShowConfirm(false); // Reset confirmation state
                }}
                sx={{ color: "grey", borderColor: "green" }}
                size="small"
                variant="outlined"
              >
                Yes
              </Button>
              <Button
                onClick={() => setShowConfirm(false)}
                sx={{ color: "grey", borderColor: "red" }}
                size="small"
                variant="outlined"
              >
                No
              </Button>
            </Box>
          ) : (
            <IconButton disabled={trueDisable} onClick={() => setShowConfirm(true)}>
              {loading ? <CircularProgress /> : <Save sx={{ color: "grey" }} />}
            </IconButton>
          )}
        </Box>
        <Divider />

        <Box sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
          <Box sx={{ display: "flex", gap: "1rem" }}>
            <Box sx={{ width: "50%" }}>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                Current Parent Asset
              </Typography>

              <TextField
                size={"small"}
                type="text"
                name="fromParentAssetId"
                variant="standard"
                placeholder="Enter Asset"
                value={
                  formik.values.fromParentAssetCode || formik.values.fromParentAssetName
                    ? `${formik.values.fromParentAssetCode}-${formik.values.fromParentAssetName}`
                    : "--"
                }
                inputProps={{ readOnly: true }}
                fullWidth
                sx={{
                  ".MuiInputBase-input": {
                    fontSize: "13px",
                  },
                }}
              />
            </Box>
            <Box sx={{ width: "50%" }}>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                To Parent Asset
              </Typography>

              <Autocomplete
                size="small"
                disabled={disableAsset || trueDisable}
                options={parentAssetList}
                getOptionLabel={(option) =>
                  option.code + " - " + option.assetName || option
                }
                value={
                  parentAssetList.find((a) => a.id === asset.id) || null
                }
                onChange={(event, value) => {
                  if (value) {
                    setAsset({ name: value.assetName, id: value.id, code: value.code });
                    setToLocation({
                      name: value.locationName || "",
                      id: value.locationId || "",
                      code: value.locationCode || "",
                    });
                    sedisableLocation(true);
                    if (isSystem) {
                      setToSystem({
                        name: value.systemName || "",
                        id: value.systemId || "",
                        code: value.systemCode || "",
                      });
                      setDisableSystem(true);
                    }
                  } else {
                    setAsset({ id: "", code: "", name: "" });
                    setToLocation({ id: "", code: "", name: "" });
                    setToSystem({ id: "", code: "", name: "" });
                    sedisableLocation(false);
                    setDisableSystem(false);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    placeholder="Select Parent Asset"
                    sx={{
                      ".MuiInputBase-input": {
                        fontSize: "13px",
                      },
                    }}
                  />
                )}
              />
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: "1rem" }}>
            <Box sx={{ width: "50%" }}>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                Current Location
              </Typography>
              <TextField
                size={"small"}
                type="text"
                name="fromLocationId"
                variant="standard"
                placeholder="Enter Current Location"
                value={
                  formik.values.fromLocationCode || formik.values.fromLocationName
                    ? `${formik.values.fromLocationCode}-${formik.values.fromLocationName}`
                    : "--"
                }
                inputProps={{ readOnly: true }}
                fullWidth
                sx={{
                  ".MuiInputBase-input": {
                    fontSize: "13px",
                  },
                }}
              />
            </Box>
            <Box sx={{ width: "50%" }}>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                To Location
              </Typography>
              <Autocomplete
                size="small"
                disabled={disableLocation || trueDisable}
                options={locationList}
                getOptionLabel={(option) =>
                  option.code + " - " + option.locationName || option
                }
                value={
                  locationList.find((loc) => loc.id === toLocation.id) || null
                }
                onChange={(event, value) => {
                  if (value) {
                    setToLocation({ name: value.locationName, id: value.id, code: value.code });
                  } else {
                    setToLocation({ id: "", code: "", name: "" });
                    setdisableAsset(false);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    placeholder="Select Location"
                    sx={{
                      ".MuiInputBase-input": {
                        fontSize: "13px",
                      },
                    }}
                  />
                )}
              />
            </Box>
          </Box>
          {isSystem && (
          <Box sx={{ display: "flex", gap: "1rem" }}>
            <Box sx={{ width: "50%" }}>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                Current System
              </Typography>
              <TextField
                size={"small"}
                type="text"
                name="fromSystemId"
                variant="standard"
                placeholder="Enter Current System"
                value={
                  formik.values.fromSystemCode || formik.values.fromSystemName
                    ? `${formik.values.fromSystemCode}-${formik.values.fromSystemName}`
                    : "--"
                }
                inputProps={{ readOnly: true }}
                fullWidth
                sx={{
                  ".MuiInputBase-input": {
                    fontSize: "13px",
                  },
                }}
              />
            </Box>
            <Box sx={{ width: "50%" }}>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                To System
              </Typography>
              <Autocomplete
                size="small"
                disabled={disableSystem || trueDisable}
                options={systemList}
                getOptionLabel={(option) =>
                  option.systemCode + " - " + option.systemName || option
                }
                value={
                  systemList.find((sys) => sys.id === toSystem.id) || null
                }
                onChange={(event, value) => {
                  if (value) {
                    setToSystem({
                      name: value.systemName,
                      id: value.id,
                      code: value.systemCode,
                    });
                  } else {
                    setToSystem({ name: "", id: "", code: "" });
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    placeholder="Select System"
                    sx={{
                      ".MuiInputBase-input": {
                        fontSize: "13px",
                      },
                    }}
                  />
                )}
              />
            </Box>
          </Box>
          )}
          {/* <Box sx={{ display: "flex", gap: "1rem" }}>
            <Box sx={{ width: "50%" }}>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                Row
              </Typography>
              <TextField
                variant="standard"
                size={"small"}
                type="text"
                name="row"
                value={formik.values.row}
                placeholder="Enter Row"
                onChange={formik.handleChange}
                fullWidth
                sx={{
                  // width: "100%",
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",
                    fontSize: "13px",

                    // "&::placeholder": {
                    //   // color: "green",
                    //   opacity: 1,
                    //   color: color.placeholderColor,
                    //   fontSize: "13px",
                    // },
                  },
                }}
              />
            </Box>
            <Box sx={{ width: "50%" }}>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                Asile
              </Typography>
              <TextField
                variant="standard"
                size={"small"}
                type="text"
                name="asile"
                value={formik.values.asile}
                placeholder="Enter Asile"
                onChange={formik.handleChange}
                fullWidth
                sx={{
                  // width: "100%",
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",
                    fontSize: "13px",

                    // "&::placeholder": {
                    //   // color: "green",
                    //   opacity: 1,
                    //   color: color.placeholderColor,
                    //   fontSize: "13px",
                    // },
                  },
                }}
              />
            </Box>
          </Box> */}
          <Box sx={{ display: "flex", gap: "1rem" }}>
            {/* <Box sx={{ width: "50%" }}>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                Bin No
              </Typography>
              <TextField
                variant="standard"
                size={"small"}
                type="text"
                name="binNo"
                value={formik.values.binNo}
                placeholder="Enter Bin No"
                onChange={formik.handleChange}
                fullWidth
                sx={{
                  // width: "100%",
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",
                    fontSize: "13px",

                    // "&::placeholder": {
                    //   // color: "green",
                    //   opacity: 1,
                    //   color: color.placeholderColor,
                    //   fontSize: "13px",
                    // },
                  },
                }}
              />
            </Box> */}
            <Box sx={{ width: "50%" }}>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                Remark
              </Typography>
              <TextField
                variant="standard"
                size={"small"}
                type="text"
                name="remarks"
                value={formik.values.remarks}
                placeholder="Enter Remarks"
                onChange={formik.handleChange}
                fullWidth
                sx={{
                  // width: "100%",
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",
                    fontSize: "13px",

                    // "&::placeholder": {
                    //   // color: "green",
                    //   opacity: 1,
                    //   color: color.placeholderColor,
                    //   fontSize: "13px",
                    // },
                  },
                }}
              />
            </Box>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default Transfer;
